import React from "react";

// Red de seguridad para la web pública.
//
// Buena parte del contenido llega del CMS, así que un campo con una forma
// inesperada puede hacer que un renderer lance. Sin este límite, React
// desmonta el árbol entero y el visitante se queda con una página en blanco
// sin ninguna pista de qué ha pasado ni cómo salir.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Error no controlado en la web pública:", error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="min-h-screen flex flex-col items-center justify-center px-6 text-center bg-background">
        <img
          src="/logos/logo-icono.png"
          alt=""
          className="h-14 w-auto opacity-25 mb-8"
        />
        <h1
          className="font-heading font-bold text-foreground mb-4"
          style={{ fontSize: "var(--text-h2)" }}
        >
          Algo no ha ido bien
        </h1>
        <p className="text-muted-foreground max-w-md mb-8 leading-relaxed">
          No hemos podido mostrar esta página. Puedes recargar o volver al
          inicio; si el problema persiste, escríbenos y lo revisamos.
        </p>
        <div className="flex flex-col sm:flex-row gap-3">
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{ borderRadius: "var(--radius-pill)" }}
            className="px-7 py-3 text-sm font-medium bg-primary text-primary-foreground hover:opacity-90 transition-opacity focus-ring"
          >
            Recargar la página
          </button>
          {/* Enlace nativo a propósito, no <Link>: este límite envuelve al
              propio router, así que un <Link> aquí llamaría a useContext fuera
              del Router y volvería a lanzar, dejando la pantalla en blanco —
              justo lo que este componente existe para evitar. */}
          <a
            href="/"
            style={{ borderRadius: "var(--radius-pill)" }}
            className="px-7 py-3 text-sm font-medium border border-border text-foreground hover:bg-muted transition-colors focus-ring"
          >
            Ir al inicio
          </a>
        </div>
      </div>
    );
  }
}
